export const scrollPageToTop = () => {
  window.scrollTo(0, 0);
};
export const scrollPageToFirstError = (errorClass) => {
  const elements = document.getElementsByClassName(errorClass);
  if (elements.length <= 0) {
    return;
  }
  const parentEl = elements[0].parentElement;
  parentEl.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
};
